import { render } from "./TransferRequest.vue?vue&type=template&id=fb5b4f9c"
const script = {}
script.render = render

export default script